import { get } from '@vueuse/core'

export const getPartIdFromRoute = routeRequest => {
  const routeParams = get(routeRequest)?.params || {}
  const partId = routeParams?.partId
  return partId
}
